var Teams = new (class Teams extends AbstractModule {

  constructor() {
    super("Teams");
  }

  _initData(data) {
    let teams     = null;
    let allTeams  = null;

    if (data.widget.teams) {
      teams       = [];
      allTeams    = [];

      for (let id = 0 ; id < data.widget.teams.length ; id++) {
        let team = new Team(data.widget.teams[id])
        teams.push(team);
        allTeams.push(team);

        for (let subId = 0 ; subId < team.children.length ; subId++) {
          allTeams.push(team.children[subId]);
        }
      }
    }

    this._autoInit({
      "list"   : [ teams, [] ],
      "allList": [ allTeams, [] ]
    });
  }

  find(id) {
    return this.allList.filter(team => team.id == id)[0]
  }

  findOrDefault(id) {
    let team = this.find(id)
    return team ? team : this.default;
  }

  get default() {
    let defaultTeam = Utils.cacheSync('teams', 'default', () => {
      return this.allList.sort((a, b) => {
        if (a.kind == b.kind) {
          return a.id < b.id ? -1 : 1;
        }
        else {
          return a.kind == 'one' ? -1 : 1;
        }
      })[0];
    });
    // if (!defaultTeam) Utils.publicError("Couldn't get default topic. Please make sure that at least one topic is enabled.");
    return defaultTeam;
  }

  _kind(all, kind, displayed = null) {
    if (["one", "many"].indexOf(kind) == -1)
      throw "Unknown Team kind";
    let cacheGroup = all ? 'allTeams' : 'teams';
    let cacheName  = kind + "_" + (displayed === null ? "null" : displayed);
    let list = this[all ? 'allList' : 'list'];

    return Utils.cacheSync(cacheGroup, cacheName, () => {
      return list.filter(team => team.kind == kind && (displayed === null || team.displayed === displayed));
    });
  }

  kind(kind, displayed = null) {
    return this._kind(false, kind, displayed);
  }

  allKind(kind, displayed = null) {
    return this._kind(true, kind, displayed);
  }

  get count() {
    return Object.keys(this.allList).length;
  }

  /**
   * enterState
   * @param  {Conversation} conversation
   * @return {Promise}      true: User was prompted to select a team
   *                        false: A team has been automatically selected
   */
  async enterState(conversation) {
    if (this.app._forced_user_group_id) {
      conversation.user_group_id = this.app._forced_user_group_id;
      return false;
    }
    else if (this.kind('one', true).length > 1 || this.allKind('one', true).length > 1) {
      Utils.logState(conversation, 'Team selection');
      let availableTeams = this.kind('one', true);

      if (this.kind('one', true).length <= 1) {
        availableTeams = this.allKind('one', true).filter(team => team != availableTeams[0])
      }

      await this.renderTeams(conversation, availableTeams);
      return true;
    } else {
      return false;
    }
  }

  renderTeams(conversation, teams, isChild = false, sutitle = null) {
    return new Promise((resolve, reject) => {

      let userGroupsHtml = this._getTeamAskingContent(conversation, teams, isChild, sutitle, true);

      let message = new Message(Faqs.enabled('online') ? MS.bot : MS.support);
      message.text = userGroupsHtml;
      message.plain_text = Wording.group_asking_title;
      message.mandatory_buttons = true;

      message.addInteraction({
        selector: '.slaask-groups-item-click',
        event: 'click',
        removeButtons: true,
        printResponse: e => {
          if (Utils.dataSet(e.currentTarget, 'children') != 'true') {
            return e.currentTarget.innerHTML
          }
        },
        handler: e => {
          let teamId = Utils.dataSet(e.currentTarget, 'id');
          let selectedTeam = this.find(parseInt(teamId));

          if (
            Utils.dataSet(e.currentTarget, 'children') == 'true'
            && selectedTeam.children.filter(child => child.displayed).length > 0
          ) {
            Utils.logState(conversation, 'Subteam selection');
            message.text = this._getTeamAskingContent(conversation, selectedTeam.children, true, selectedTeam.name);
            Conversations.updateMessage(message);
            return false;
          } else {
            conversation.user_group_id = selectedTeam.id;

            Views.syncTitle();

            if (!this.app._manual_messages_activated && conversation.kind != 'many') {
              this.app._setOneToSlackChannel()
            }
            else this.app._setManyToManyChannel(conversation);

            // message.text = Wording.md('group_asking_title')
            // Conversations.updateMessage(message)

            resolve(true);
          }
        }
      });

      message.addInteraction({
        selector: '#slaask-user-group-back',
        event: 'click',
        handler: e => {
          message.text = this._getTeamAskingContent(conversation, this.kind('one'));
          Conversations.updateMessage(message);
        }
      });

      conversation.addMessage(message, true);
    });
  }

  _getTeamAskingContent(conversation, teams, isChild = false, sutitle = null, firstLoad = false) {
    let userGroupsHtml  = ''

    for (let i = 0; i < teams.length; i++) {
      let team      = teams[i]
      if (team.displayed) {
        let hasChilds = team.children.length != 0
        let cssClass  = 'slaask-btn slaask-groups-item-click'

        if (firstLoad) { cssClass = cssClass + ' slow-loading' }

        userGroupsHtml += `<div data-id="${team.id}" data-children="${hasChilds}" data-kind="${team.kind}" data-alert="${team.alert}" id="slaask-user-group-${team.id}" class="${cssClass}">${team.name}</div>`
      }
    }

    if(isChild) {
      userGroupsHtml += '<div data-id="back" data-children="false" id="slaask-user-group-back" class="slaask-btn">' + Svg.back('#444', 12) + '&nbsp;' + Wording.back + '</div>'
    }

    let hover_color;
    if (this.app._chat_color == '#ffffff') {
      hover_color = '#E01765'
    }
    else {
      hover_color = this.app._chat_color
    }

    if (sutitle) {
      userGroupsHtml = Wording.md('group_asking_title') + sutitle + Wording.colon + userGroupsHtml;
    } else {
      userGroupsHtml = Wording.md('group_asking_title') + userGroupsHtml;
    }

    return userGroupsHtml;
  }

});
